export default function Codes() {
  return (
    <div className="longpage">

    <h2 className=""> Example 1: This Website! </h2>
        <p className="black">If it was not already assumed, I wrote the code for this website myself using the React.js library for the frontend and GitHub actions, yarn, and Microsoft Azure to deploy. </p>

        <h2 className=""> Example 2: The Virtual Detention </h2>
        <p className="black"> This was my capstone for the software engineering bootcamp where I began my studies.
    While AI was not a part of the program, by the end I was heavily interested.
    To incorporate this, I integrated the BERT Q&A model into my website using TensorFlow backend, allowing users to extract details from the content of a given passage through q&a. 
         </p>

        <h3>ToolKit</h3>
        <p className="black"> TensorFlow BERT Model from TensorFlowHub w/ Tensorflow cpu, WebGL, Node.js, and React.js for AI and Frontend, Azure to deploy, Axios to fetch 3rd party API
        from NASA, and TensorFlow BERT Q&A model for Natural Language Question Answering.</p>
          
        <a className="github" href="https://proud-plant-0981ce810.3.azurestaticapps.net/"> Site Link - Click here to go to the Virtual Class! </a>
          
       <h3>Snapshots</h3>
       <img className="exampleer" src="https://i.imgur.com/9qRZRqA.jpg" align="center" alt="capstone1"></img>
       <img className="exampleer" src="https://i.imgur.com/QDDD5Vu.jpg" align="center" alt="capstone2"></img>
       
      </div>
    )
  }

/*

        <img className="exampleer" src="https://i.postimg.cc/vmQfCVr6/0954-CFAF-BFE4-42-A3-BDDF-84-C940473277-1-201-a.jpg" align="center" alt="capstone1"></img>

 serving as a virtual tutor in The Virtual Classroom Detention
 
Simply put, the Virtual Classroom / Detention is where the non-traditional students like me get sent to go supplement our clasroom education after being kicked out
        of traditional classrooms for "poor classroom performance" so they can learn on their own time!
        
and for data seeding I am working with MongoDB
*/
